import { render, staticRenderFns } from "./images-upload.vue?vue&type=template&id=16778ce8&scoped=true"
import script from "./images-upload.vue?vue&type=script&lang=ts"
export * from "./images-upload.vue?vue&type=script&lang=ts"
import style0 from "./images-upload.vue?vue&type=style&index=0&id=16778ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16778ce8",
  null
  
)

export default component.exports